import { 
    WorkflowDefinition, 
    WorkflowAssignment, 
    WorkflowDefinitionDto, 
    WorkflowAssignmentDto 
} from "../../interfaces/superAdmin/SuperAdmin";

// --- DEFINITIONS (Templates) ---

export async function getDefinitions(authToken: string, orgId: number): Promise<WorkflowDefinition[] | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/workflow/${orgId}/definitions`, {
            headers: { 'Authorization': `Bearer ${authToken}` },
        });
        if (!response.ok) return null;
        
        const data: WorkflowDefinition[] = await response.json();
        
        // Auto-parse the JSON string for the UI
        return data.map(d => ({
            ...d,
            workflowConfig: typeof d.configJson === 'string' ? JSON.parse(d.configJson) : d.configJson
        }));
    } catch (error) {
        console.error("Error fetching definitions:", error);
        return null;
    }
}

export async function upsertDefinition(authToken: string, orgId: number, dto: WorkflowDefinitionDto): Promise<WorkflowDefinition | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/workflow/${orgId}/definitions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(dto),
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (error) {
        console.error("Error saving definition:", error);
        return null;
    }
}

// --- ASSIGNMENTS (Rules) ---

export async function getAssignments(authToken: string, orgId: number): Promise<WorkflowAssignment[] | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/workflow/${orgId}/assignments`, {
            headers: { 'Authorization': `Bearer ${authToken}` },
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (error) {
        console.error("Error fetching assignments:", error);
        return null;
    }
}

export async function upsertAssignment(authToken: string, orgId: number, dto: WorkflowAssignmentDto): Promise<WorkflowAssignment | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/workflow/${orgId}/assignments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(dto),
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (error) {
        console.error("Error saving assignment:", error);
        return null;
    }
}

export async function deleteAssignment(authToken: string, orgId: number, assignmentId: number): Promise<boolean> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/workflow/${orgId}/assignments/${assignmentId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${authToken}` },
        });
        return response.ok;
    } catch (error) {
        console.error("Error deleting assignment:", error);
        return false;
    }
}

export async function getWorkflowReferenceData(authToken: string, orgId: number) {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/superadmin/workflow/${orgId}/reference-data`, {
            headers: { 'Authorization': `Bearer ${authToken}` },
        });
        if (!response.ok) return null;
        return await response.json();
    } catch (error) {
        console.error("Error fetching workflow reference data:", error);
        return null;
    }
}